export default __webpack_public_path__ + "static/media/upper-silhouette.e3338e27.svg";